import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { creatorAPI } from '../services/api';
import LoadingAnimation from '../components/LoadingAnimation';
import './MySubscriptions.css';

const MySubscriptions = () => {
  const navigate = useNavigate();
  const [subscriptions, setSubscriptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    loadSubscriptions();
  }, []);

  const loadSubscriptions = async () => {
    try {
      setLoading(true);
      const response = await creatorAPI.getMySubscriptions();
      setSubscriptions(response.data || []);
    } catch (err) {
      console.error('Failed to load subscriptions:', err);
      setError('Failed to load subscriptions');
    } finally {
      setLoading(false);
    }
  };

  const handleUnsubscribe = async (creatorId) => {
    if (!window.confirm('Are you sure you want to unsubscribe?')) {
      return;
    }

    try {
      await creatorAPI.unsubscribe(creatorId);
      await loadSubscriptions();
    } catch (err) {
      console.error('Failed to unsubscribe:', err);
      setError('Failed to unsubscribe');
    }
  };

  if (loading) {
    return (
      <div className="subscriptions-container">
        <LoadingAnimation />
      </div>
    );
  }

  return (
    <div className="subscriptions-container">
      <div className="subscriptions-header">
        <h1>My Subscriptions</h1>
        <p>Creator subscriptions are available in Phase 2</p>
      </div>

      <div className="empty-state">
        <div className="empty-icon">🎉</div>
        <h2>PHASE 1 - All Content is Free!</h2>
        <p>Creator subscriptions are currently disabled. All creator content is free to access in Phase 1.</p>
        <button 
          className="btn btn-primary"
          onClick={() => navigate('/discover')}
        >
          Browse Creators
        </button>
      </div>
    </div>
  );
};

export default MySubscriptions;
